const _debug = {
    output: true,
    getArguments: function (args) {
        const arr = [];
        for (let i = 0; i < args.length; i++) {
            arr[i] = args[i];
        }
        return arr;
    },
    info: function () {
        this.write("info", this.getArguments(arguments));
    },
    log: function () {
        this.write("log", this.getArguments(arguments));
    },
    warn: function () {
        this.write("warn", this.getArguments(arguments));
    },
    error: function () {
        this.write("error", this.getArguments(arguments));
    },
    debug: function () {
        this.write("debug", this.getArguments(arguments));
    },
    write: function (level, args) {
        if (this.output && typeof (console) === "object") {
            window.console[level](args);
        }
    }
};

module.exports = _debug;